import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NaviMumbaiAirportToNashikCab() {



    const cardData = {





keyword: "Navi Mumbai Airport to Nashik Cab",

headingDescription: "Shreesha Tours & Travels offers dependable Navi Mumbai Airport to Nashik Cab Service for airport transfers, family travel, business trips, corporate transportation, pilgrimage tours, one-way taxi booking, round trips, and outstation journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles to ensure a comfortable and safe journey from Navi Mumbai Airport to Nashik. Our professional drivers, flight tracking, on-time airport pickups, well-maintained vehicles, transparent pricing, doorstep drop service, flexible booking options, and 24/7 customer support guarantee a smooth travel experience. Whether you are traveling for Trimbakeshwar Darshan, vineyard tours, business meetings, family visits, or sightseeing, Shreesha Tours & Travels delivers reliable airport cab services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Trimbakeshwar Jyotirlinga",
    description: "Trimbakeshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and one of Nashik's most visited pilgrimage destinations, attracting devotees throughout the year."
  },
  {
    title: "Panchavati",
    description: "Panchavati is a famous religious area associated with the Ramayana, known for Kalaram Temple, Sita Gufa, Ramkund, and other sacred attractions."
  },
  {
    title: "Sula Vineyards",
    description: "Sula Vineyards is India's most famous vineyard destination, offering wine tasting, vineyard tours, fine dining, and beautiful countryside views."
  },
  {
    title: "Muktidham Temple",
    description: "Muktidham Temple is a beautiful marble temple complex featuring replicas of important Hindu temples and sacred shrines, making it a popular religious attraction."
  },
  {
    title: "Pandavleni Caves",
    description: "Pandavleni Caves are ancient Buddhist rock-cut caves known for their historical significance, sculptures, inscriptions, and panoramic views of Nashik."
  },
  {
    title: "Anjaneri Hills",
    description: "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a favorite destination for trekking, nature lovers, and spiritual visitors."
  },
  {
    title: "Saptashrungi Devi Temple",
    description: "Saptashrungi Temple is one of Maharashtra's revered Shakti Peethas, attracting thousands of devotees for darshan and religious ceremonies."
  },
  {
    title: "Harihar Fort",
    description: "Harihar Fort is a popular trekking destination near Nashik, famous for its steep rock-cut staircase, panoramic mountain views, and adventurous trails."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic hill station near Nashik known for Vipassana International Academy, waterfalls, lush greenery, and beautiful Sahyadri landscapes."
  },
  {
    title: "Coin Museum",
    description: "The Indian Institute of Research in Numismatic Studies Coin Museum is a unique attraction in Nashik showcasing rare coins, currency history, and historical collections."
  }
],


"services": [
  {
    "name": "Navi Mumbai to Nashik Cab",
    "description": "Book Navi Mumbai to Nashik Cab for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cabs for family trips, business travel, weekend getaways, and airport transfers with transparent pricing and 24x7 service."
  },
  {
    "name": "Navi Mumbai Airport to Nashik Cab",
    "description": "Reserve Navi Mumbai Airport to Nashik Cab for direct airport pickup with experienced chauffeurs and comfortable AC vehicles. Enjoy timely airport transfers, luggage assistance, flight tracking, and doorstep drop anywhere in Nashik."
  },
  {
    "name": "Navi Mumbai Airport to Nashik Taxi",
    "description": "Choose Navi Mumbai Airport to Nashik Taxi for affordable and convenient airport transportation with professional drivers, clean vehicles, and reliable pickup services available throughout the day."
  },
  {
    "name": "Navi Mumbai Airport to Nashik Cab Service",
    "description": "Book Navi Mumbai Airport to Nashik Cab Service for hassle-free airport transfers with premium vehicles, courteous chauffeurs, flexible pickup timings, and comfortable long-distance travel."
  },
  {
    "name": "Taxi from Navi Mumbai Airport to Nashik",
    "description": "Hire Taxi from Navi Mumbai Airport to Nashik for safe and comfortable airport transportation with well-maintained AC vehicles, experienced drivers, and reliable service for business and leisure travelers."
  },
  {
    "name": "Cab from Navi Mumbai Airport to Nashik",
    "description": "Choose Cab from Navi Mumbai Airport to Nashik for convenient airport pickup and direct transportation with professional chauffeurs, luggage assistance, and flexible booking options."
  },
  {
    "name": "Navi Mumbai to Nashik Cab Fare",
    "description": "Get affordable Navi Mumbai to Nashik Cab Fare with transparent pricing, no hidden charges, comfortable AC vehicles, and dependable chauffeur-driven taxi services for every journey."
  },
  {
    "name": "Book Cab Navi Mumbai Airport to Nashik",
    "description": "Book Cab Navi Mumbai Airport to Nashik with instant confirmation and multiple vehicle options. Enjoy easy reservations, professional drivers, and comfortable airport transfers at competitive prices."
  },
  {
    "name": "Online Cab Booking Navi Mumbai Airport to Nashik",
    "description": "Complete Online Cab Booking Navi Mumbai Airport to Nashik with secure reservations, quick confirmation, transparent fares, and 24x7 customer support for stress-free airport transportation."
  },
  {
    "name": "Best Cab Navi Mumbai Airport to Nashik",
    "description": "Choose the Best Cab Navi Mumbai Airport to Nashik for premium airport transfers with experienced chauffeurs, clean vehicles, punctual pickups, and excellent customer service."
  },
  {
    "name": "Cheapest Cab Navi Mumbai Airport to Nashik",
    "description": "Book the Cheapest Cab Navi Mumbai Airport to Nashik with budget-friendly pricing, reliable drivers, comfortable AC vehicles, and quality airport transfer services without compromising safety."
  },
  {
    "name": "Reliable Taxi Navi Mumbai Airport to Nashik",
    "description": "Reserve Reliable Taxi Navi Mumbai Airport to Nashik for dependable airport transportation with verified chauffeurs, well-maintained vehicles, flight monitoring, and comfortable long-distance travel."
  },
  {
    "name": "One Way Cab Navi Mumbai Airport to Nashik",
    "description": "Book One Way Cab Navi Mumbai Airport to Nashik for economical drop taxi service without return charges. Enjoy convenient pickups, comfortable rides, and professional chauffeurs."
  },
  {
    "name": "Round Trip Cab Navi Mumbai Airport to Nashik",
    "description": "Choose Round Trip Cab Navi Mumbai Airport to Nashik for return travel with flexible schedules, premium vehicles, and experienced drivers for family visits, business travel, and holiday trips."
  },
  {
    "name": "Airport Pickup Cab Navi Mumbai to Nashik",
    "description": "Reserve Airport Pickup Cab Navi Mumbai to Nashik for timely airport arrivals with professional chauffeurs, luggage support, and direct transportation to your destination in Nashik."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai Airport to Nashik",
    "description": "Book Innova Crysta Cab Navi Mumbai Airport to Nashik for luxury airport transfers with spacious seating, premium interiors, extra luggage capacity, and comfortable long-distance travel."
  },
  {
    "name": "Innova Cab Navi Mumbai Airport to Nashik",
    "description": "Choose Innova Cab Navi Mumbai Airport to Nashik for spacious airport transportation with comfortable seating, professional drivers, and smooth travel for families and business groups."
  },
  {
    "name": "Ertiga Cab Navi Mumbai Airport to Nashik",
    "description": "Reserve Ertiga Cab Navi Mumbai Airport to Nashik for affordable family airport transfers with comfortable seating, clean AC vehicles, and reliable chauffeur-driven service."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai Airport to Nashik",
    "description": "Book Swift Dzire Cab Navi Mumbai Airport to Nashik for economical airport transportation with clean AC sedans, experienced chauffeurs, and timely pickup services."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai Airport to Nashik",
    "description": "Choose Kia Carens Cab Navi Mumbai Airport to Nashik for premium family travel with spacious seating, modern interiors, and comfortable airport transportation."
  },
  {
    "name": "Sedan Cab Navi Mumbai Airport to Nashik",
    "description": "Book Sedan Cab Navi Mumbai Airport to Nashik for affordable and comfortable airport transfers with professional drivers, clean AC vehicles, and reliable service."
  },
  {
    "name": "SUV Cab Navi Mumbai Airport to Nashik",
    "description": "Reserve SUV Cab Navi Mumbai Airport to Nashik for spacious airport transportation with additional luggage capacity, premium comfort, and experienced chauffeurs."
  },
  {
    "name": "Hyundai Aura Cab Navi Mumbai Airport to Nashik",
    "description": "Choose Hyundai Aura Cab Navi Mumbai Airport to Nashik for budget-friendly airport transfers with clean AC vehicles, courteous drivers, and comfortable travel from the airport to Nashik."
  }
],
"tableData": [
  ["Navi Mumbai to Nashik Cab", "Navi Mumbai Airport to Nashik Cab"],
  ["Navi Mumbai Airport to Nashik Taxi", "Navi Mumbai Airport to Nashik Cab Service"],
  ["Taxi from Navi Mumbai Airport to Nashik", "Cab from Navi Mumbai Airport to Nashik"],
  ["Navi Mumbai to Nashik Cab Fare", "Book Cab Navi Mumbai Airport to Nashik"],
  ["Online Cab Booking Navi Mumbai Airport to Nashik", "Best Cab Navi Mumbai Airport to Nashik"],
  ["Cheapest Cab Navi Mumbai Airport to Nashik", "Reliable Taxi Navi Mumbai Airport to Nashik"],
  ["One Way Cab Navi Mumbai Airport to Nashik", "Round Trip Cab Navi Mumbai Airport to Nashik"],
  ["Airport Pickup Cab Navi Mumbai to Nashik", "Innova Crysta Cab Navi Mumbai Airport to Nashik"],
  ["Innova Cab Navi Mumbai Airport to Nashik", "Ertiga Cab Navi Mumbai Airport to Nashik"],
  ["Swift Dzire Cab Navi Mumbai Airport to Nashik", "Kia Carens Cab Navi Mumbai Airport to Nashik"],
  ["Sedan Cab Navi Mumbai Airport to Nashik", "SUV Cab Navi Mumbai Airport to Nashik"],
  ["Hyundai Aura Cab Navi Mumbai Airport to Nashik", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Nashik Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Navi Mumbai Airport to Nashik cab services for business travellers, families, pilgrims, tourists, and corporate clients. Enjoy a seamless airport transfer with comfortable vehicles and experienced chauffeurs."
  },
  {
    WhyChooseheading: "Direct Airport Transfer to Any Location in Nashik",
    WhyChoosedescription: "Travel directly from Navi Mumbai Airport to Nashik Road, Panchavati, Trimbakeshwar, Gangapur Road, Satpur MIDC, CIDCO, Deolali, hotels, homes, or business destinations without changing vehicles."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle for Your Trip",
    WhyChoosedescription: "Book Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for comfortable airport transportation based on your group size and luggage."
  },
  {
    WhyChooseheading: "Suitable for Pilgrimage, Business & Family Travel",
    WhyChoosedescription: "Our Navi Mumbai Airport to Nashik cabs are ideal for Trimbakeshwar temple visits, corporate travel, vineyard tours, family holidays, hotel transfers, medical appointments, and personal journeys."
  },
  {
    WhyChooseheading: "Flexible One-Way & Return Airport Transfers",
    WhyChoosedescription: "Reserve a one-way airport taxi to Nashik or choose a round-trip package with customized return schedules, waiting options, and multiple stopovers if required."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Highway Travel",
    WhyChoosedescription: "Our trained drivers have extensive knowledge of Mumbai-Nashik highways and provide safe driving, timely pickups, and a relaxing travel experience throughout the journey."
  },
  {
    WhyChooseheading: "Well-Maintained Cars for Comfortable Airport Rides",
    WhyChoosedescription: "Every vehicle is thoroughly cleaned, air-conditioned, sanitized, and regularly serviced to ensure passengers enjoy a pleasant and dependable airport transfer."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport to Nashik Cab with Shreesha Travels",
    WhyChoosedescription: "Benefit from transparent pricing, quick booking confirmation, courteous chauffeur service, and reliable airport transportation from Navi Mumbai Airport to Nashik."
  }
]

};

const faqData = [
  {
    question: "Can I pre-book a cab from Navi Mumbai Airport to Nashik?",
    answer: "Yes, you can reserve your airport cab in advance by sharing your flight details, arrival time, and destination in Nashik."
  },
  {
    question: "Do you provide direct airport transfers to Trimbakeshwar from Navi Mumbai Airport?",
    answer: "Yes, we offer direct cab services from Navi Mumbai Airport to Trimbakeshwar Temple and other destinations in and around Nashik."
  },
  {
    question: "Which vehicles are available for Navi Mumbai Airport to Nashik travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a one-way airport cab to Nashik?",
    answer: "Yes, one-way airport transfers are available along with round-trip and customized travel packages."
  },
  {
    question: "Is this airport cab suitable for business travellers?",
    answer: "Yes, our service is ideal for corporate executives, industrial visits, business meetings, and official travel to Nashik."
  },
  {
    question: "Will the driver wait if my flight arrival is delayed?",
    answer: "Yes, flight details are considered during scheduling so pickups can be coordinated whenever possible."
  },
  {
    question: "Are airport transfers available during late-night hours?",
    answer: "Yes, Navi Mumbai Airport to Nashik cab services are available 24x7 for scheduled arrivals and departures."
  },
  {
    question: "How is the Navi Mumbai Airport to Nashik cab fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, trip timing, tolls, parking charges, and additional travel requirements."
  },
  {
    question: "Can I add sightseeing stops during my journey?",
    answer: "Yes, customized travel plans with sightseeing or multiple stopovers can be arranged according to your itinerary."
  },
  {
    question: "How can I book Navi Mumbai Airport to Nashik Cab with Shreesha Travels?",
    answer: "Simply provide your flight details, travel date, destination, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "Excellent airport transfer to Nashik. The driver reached on time, the vehicle was comfortable, and the journey was smooth from beginning to end.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Bhakti Kulkarni",
    feedback: "We travelled from Navi Mumbai Airport to Nashik with our family, and everything was perfectly managed. The car was clean, spacious, and the service was highly professional.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Nashik Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-airport-to-nashik-cab.webp",
  "description":
    "Book Navi Mumbai Airport to Nashik Cab with Shreesha Tours & Travels for safe and reliable airport taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way, round-trip, family travel, business travel, and comfortable outstation journeys from Navi Mumbai Airport to Nashik with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-airport-to-nashik-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Navi Mumbai Airport to Nashik Cab | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Nashik Cab with Shreesha Travels for safe and comfortable airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way, round-trip, family trips, business travel, and 24x7 airport transfers from Navi Mumbai Airport to Nashik."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Nashik Cab, Navi Mumbai Airport to Nashik Cab, Navi Mumbai Airport to Nashik Taxi, Navi Mumbai Airport to Nashik Cab Service, Taxi from Navi Mumbai Airport to Nashik, Cab from Navi Mumbai Airport to Nashik, Navi Mumbai to Nashik Taxi, One Way Cab Navi Mumbai to Nashik, Airport Taxi Navi Mumbai to Nashik, Nashik Airport Transfer"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NaviMumbaiAirportToNashikCab;